<template>
  <div class="row">
    <div class="col-md-6 form-group">
      <label>IMEI</label>
      <input
        v-model="value.imei"
        type="text"
        class="form-control"
        :disabled="disabled"
        placeholder="IMEI"
        maxlength="20"
        @blur="$emit('lookup-key', value.imei)"
      >
      <small class="text-muted">Preencha para buscar um cadastro já existente.</small>
    </div>
    <div class="col-md-6 form-group">
      <label>Número</label>
      <input
        v-model="value.number"
        v-mask="['(##) ####-####', '(##) #####-####']"
        type="text"
        class="form-control"
        :disabled="disabled"
        placeholder="(00) 00000-0000"
      >
    </div>

    <div class="col-md-6 form-group">
      <label>Operadora</label>
      <input
        v-model="value.carrier"
        type="text"
        class="form-control"
        :disabled="disabled"
        placeholder="Ex: Vivo"
      >
    </div>
    <div class="col-md-6 form-group">
      <label>Titular</label>
      <input
        v-model="value.owner_name"
        type="text"
        class="form-control"
        :disabled="disabled"
        placeholder="Nome do titular"
      >
    </div>

    <div class="col-12 form-group">
      <label>Observação</label>
      <textarea
        v-model="value.observation"
        class="form-control"
        rows="2"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvolvedPhoneForm',
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
}
</script>
